'use client';
import { useRouter } from 'next/navigation';
import { useAuthStore } from 'store/useAuthStore';
import { useEffect } from 'react';
import { getInitialRoute } from 'lib/navigation';

export default function Home() {
  const { token, user } = useAuthStore();
  const router = useRouter();

  useEffect(() => {
    if (token && user) {
      const route = getInitialRoute(user?.permission_list);
      router.replace(route);
    } else {
      router.push('/sign-in');
    }
  }, [token]);
}
